import { faEllipsisVertical } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dropdown, Button } from "react-bootstrap";
import RemoteManagementSetup from "./RemoteManagementSetup";
import ClusterDelete from "../../cluster/ClusterDelete";
import { IClusterInfo, IConstellationInfo } from "../../../../model/CarbonExternalModels";

interface IProps {
    foundObject: { cluster: IClusterInfo; constellation: IConstellationInfo };
}

export default function ClusterCardDropdown(props: IProps) {
    return (
        <Dropdown
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <Dropdown.Toggle as={Button} className="userful-icon-dropdown ">
                <FontAwesomeIcon icon={faEllipsisVertical} />
            </Dropdown.Toggle>

            <Dropdown.Menu
                className="userful-icon-dropdown-menu"
                popperConfig={{ strategy: "fixed" }}
                renderOnMount={true}
                onKeyDown={(e) => e.stopPropagation()}
                onKeyUp={(e) => e.stopPropagation()}
            >
                <RemoteManagementSetup
                    clusterID={props.foundObject.cluster.id}
                    constellationID={props.foundObject.constellation.definition.id}
                />
                <ClusterDelete foundObject={props.foundObject} />
            </Dropdown.Menu>
        </Dropdown>
    );
}
